import { NEWS_BLOCK_RECEIVE, NEWS_BLOCK_ERROR } from './NewsBlock.action';
import { error as errorReducer } from '../../../Reducers/Error.reducer';

const defaultState = {
    result: []
}
export const NewsReducer = (state = defaultState, action) => {
    switch (action.type) {
        case NEWS_BLOCK_RECEIVE:
            return {
                ...state,
                result: [...state.result, action.payload],
            }
        case NEWS_BLOCK_ERROR:
            return {
                ...state,
                errors: errorReducer(state.errors, action)
            }
        default:
            return state;
    }
}